<template>
  <v-card outlined class="py-3 px-5 w-100">
    <table class="w-100">
      <tr class="no-row-border">
        <td class="no-border"></td>
        <td class="no-border"></td>
        <td v-for="(columnTitle, key) in keys" :key="key" class="table-title">
          {{ columnTitle }}
        </td>
      </tr>
      <tr v-for="(rowTitle, value, index) in values" :key="value">
        <td v-if="index === 0" class="table-title group no-border" rowspan="12">
          Composition
        </td>
        <td
          class="table-title no-col-border"
          :colspan="
            value === 'temp' || value === 'flow' || value === 'enthalpy'
              ? 2
              : undefined
          "
          style="width: 100px"
        >
          {{ rowTitle }}
        </td>
        <td
          v-for="(_name, key) in keys"
          :key="key"
          :class="{ empty: composition[value][key] === undefined }"
        >
          <span v-if="composition[value][key] === null">-</span>
          <span v-else-if="composition[value][key] !== undefined">
            {{ composition[value][key] }}
          </span>
          <v-icon
            v-if="rowTitle === values.co && key === 'flueGas' && reqAir > 0"
            color="info"
            size="16"
            class="ml-2"
            style="position: absolute; transform: translateX(4px)"
          >
            mdi-star
          </v-icon>
        </td>
      </tr>
    </table>
    <v-alert
      v-if="reqAir > 0"
      text
      color="info"
      icon="mdi-star"
      class="text-caption direction-rtl mt-4 mr-2"
      style="float: right"
    >
      <span
        v-html="
          $t('reqair_note', {
            reqAir: `<span dir='ltr'> ${reqAir} Nm³/h</span>`,
          })
        "
      ></span>
    </v-alert>
  </v-card>
</template>

<script>
import { COMPOSITION_KEYS, COMPOSITION_VALUES } from "../../views/balance/data";

export default {
  name: "CompositionResult",

  props: {
    composition: { type: Object, required: true },
    reqAir: { type: Number, default: 0 },
  },

  data() {
    return {
      keys: COMPOSITION_KEYS,
      values: COMPOSITION_VALUES,
    };
  },
};
</script>

<style lang="scss" scoped>
table {
  & .group {
    writing-mode: tb-rl;
    transform: rotate(-180deg);
  }
  & .empty {
    background: repeating-linear-gradient(
      135deg,
      var(--v-lightGrey-base) 0,
      var(--v-lightGrey-base) 10%,
      transparent 0,
      transparent 50%
    );
    background-size: 1em 1em;
    opacity: 1;
  }
}
</style>
